"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
// tslint:disable:max-line-length
var AttensiAPI = /** @class */ (function () {
    /**
     * Initialises the AttensiAPI with options
     * @constructor
     * @param  { AttensiAPIOptions | null } AttensiAPIOptions
     */
    function AttensiAPI(options) {
        this.portal = new __1.Portal();
        this.creator = new __1.Creator();
        if (options) {
            this.setOptions(options);
        }
    }
    /**
     * Sets options for the AttensiAPI
     * @param  { AttensiAPIOptions } AttensiAPIOptions
     */
    AttensiAPI.prototype.setOptions = function (options) {
        this.portal.setOptions(options);
        this.creator.setOptions(options);
    };
    return AttensiAPI;
}());
exports.AttensiAPI = AttensiAPI;
//# sourceMappingURL=attensiAPI.js.map